import classes from './loading.module.css';

const Loading = () => (
  <div className={classes.wrapper}>
    <div className={classes.loading}>
      <div className={classes.content}></div>
    </div>
  </div>
);
export default Loading;
